// src/api/daerahindonesia/AddressPlugin.js
import Kecamatan from './kecamatan'
import Kelurahan from './kelurahan'
import Kota from './kota'
import Provinsi from './provinsi'

export default {
  install(Vue) {
    Vue.prototype.$provinsi = Provinsi;
    Vue.prototype.$kota = Kota;
    Vue.prototype.$kecamatan = Kecamatan;
    Vue.prototype.$kelurahan = Kelurahan;
  }
};


// WEBPACK FOOTER //
// ./src/api/daerahindonesia/AddressPlugin.js